import React from "react";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { Link } from "react-router-dom";
const Breadcrumbs = () => {
  const breadcrumbs = useReactRouterBreadcrumbs();
  console.log(breadcrumbs);

  const removeStaticPath = [
    "/purchasing/PO/modify-buyer",
    "/purchasing/PO/modify-vendor",
  ];

  return (
    <React.Fragment>
      {breadcrumbs
        .filter((ele) => !removeStaticPath.includes(ele.key))
        .map(({ match, breadcrumb }, index) => (
          <span key={match.pathname}>
            <div className="brdCmb-home" key={match.url}>
              <Link
                className={
                  index ===
                  breadcrumbs.filter(
                    (ele) => !removeStaticPath.includes(ele.key)
                  ).length -
                    1
                    ? "disabled"
                    : ""
                }
                to={match.pathname}
              >
                {breadcrumb}
              </Link>
              {index <
                breadcrumbs.filter((ele) => !removeStaticPath.includes(ele.key))
                  .length -
                  1 && " / "}
            </div>
          </span>
        ))}
    </React.Fragment>
  );
};
export default Breadcrumbs;
